/** Franchise service rows — match naturals/enterprise SkinRoutinePage cart keys & titles. */

export function treatmentRowCartKey(item, idx) {
  if (item?.id != null) return `treatment_${item.id}`;
  if (item?.service_id != null) return `treatment_${item.service_id}`;
  if (item?.treatment_id != null) return `treatment_${item.treatment_id}`;
  const stableName = String(
    item?.treatment || item?.service_name || item?.treatment_name || '',
  ).trim();
  if (stableName) return `treatment_${stableName.replace(/\s+/g, '_').toLowerCase()}`;
  return `treatment_${idx}_row`;
}

export function treatmentDisplayTitle(item, idx = 0) {
  return (
    item?.treatment ||
    item?.service_name ||
    item?.treatment_name ||
    item?.name ||
    `Treatment ${idx + 1}`
  );
}

export function treatmentRecommendationLine(item) {
  const conditions = item?.suggested_for_conditions?.length
    ? item.suggested_for_conditions
    : item?.conditions || [];
  if (conditions.length) {
    return `Recommended for ${conditions.join(', ')}`;
  }
  const why = item?.suggested_for_wording || item?.suggested_for || '';
  return String(why || '')
    .replace(/\s*[—–-]\s*aligns with \d+ of your selected goal\(s\)/i, '')
    .replace(/^aligns with \d+ selected goal\(s\)$/i, '')
    .trim();
}
